import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Product, PaginatedResponse } from '../../types/app';

interface ProductsState {
  products: PaginatedResponse<Product> | null;
  selectedProduct: Product | null;
  isLoading: boolean;
  isUpdating: boolean;
  error: string | null;
}

const initialState: ProductsState = {
  products: null,
  selectedProduct: null,
  isLoading: false,
  isUpdating: false,
  error: null,
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    fetchProductsStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchProductsSuccess: (state, action: PayloadAction<PaginatedResponse<Product>>) => {
      state.isLoading = false;
      state.products = action.payload;
      state.error = null;
    },
    fetchProductsFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    selectProduct: (state, action: PayloadAction<Product>) => {
      state.selectedProduct = action.payload;
    },
    updateProductStart: (state) => {
      state.isUpdating = true;
      state.error = null;
    },
    updateProductSuccess: (state, action: PayloadAction<Product>) => {
      state.isUpdating = false;
      state.selectedProduct = action.payload;
      
      // Update product in the list
      if (state.products) {
        const index = state.products.items.findIndex(p => p.id === action.payload.id);
        if (index !== -1) {
          state.products.items[index] = action.payload;
        }
      }
      state.error = null;
    },
    updateProductFailure: (state, action: PayloadAction<string>) => {
      state.isUpdating = false;
      state.error = action.payload;
    },
    deleteProductSuccess: (state, action: PayloadAction<string>) => {
      if (state.products) {
        state.products.items = state.products.items.filter(p => p.id !== action.payload);
      }
      if (state.selectedProduct?.id === action.payload) {
        state.selectedProduct = null;
      }
    },
    clearSelectedProduct: (state) => {
      state.selectedProduct = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  fetchProductsStart,
  fetchProductsSuccess,
  fetchProductsFailure,
  selectProduct,
  updateProductStart,
  updateProductSuccess,
  updateProductFailure,
  deleteProductSuccess,
  clearSelectedProduct,
  clearError,
} = productsSlice.actions;

export default productsSlice.reducer; 